import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../../../../store/hooks';
import { getCampaignReports } from '../../../../thunks/get-campaign-reports.thunk';

export const useGetVehicleReports = (campaignId?: string) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!campaignId) {
      navigate('/campaign-management/campaigns');
      return;
    }

    dispatch(getCampaignReports({ entityId: +campaignId }));
  }, []);
};
